// Hàm kiểm tra xem năm hiện tại có nằm trong khoảng được chọn không
export var isSelectedYear = function (year, selectedDate) {
    if (Array.isArray(selectedDate) && selectedDate[0] && selectedDate[1]) {
        return year.getFullYear() >= selectedDate[0].getFullYear() && year.getFullYear() <= selectedDate[1].getFullYear();
    }
    return selectedDate instanceof Date && year.getFullYear() === selectedDate.getFullYear();
};
// Hàm kiểm tra xem năm hiện tại có phải là năm bắt đầu không
export var isStartYear = function (year, selectedDate) {
    return Array.isArray(selectedDate) && selectedDate[0] && year.getFullYear() === selectedDate[0].getFullYear();
};
// Hàm kiểm tra xem năm hiện tại có phải là năm kết thúc không
export var isEndYear = function (year, selectedDate) {
    return Array.isArray(selectedDate) && selectedDate[1] && year.getFullYear() === selectedDate[1].getFullYear();
};
